import React from 'react'
import { Plus } from 'lucide-react'
import { Button } from '@headlessui/react'

type AssociationEmptyStateProps = {
  icon: React.ReactNode
  title: string
  description: string
  /**
   * Omit `onAction` (or `actionLabel`) to render the empty state without a CTA —
   * used for RBAC view-only users, who should still see the empty state but no
   * "Add ..." affordance. Same convention as NoteList / TaskList.
   */
  actionLabel?: string
  onAction?: () => void
}

const AssociationEmptyState = ({
  icon,
  title,
  description,
  actionLabel,
  onAction,
}: AssociationEmptyStateProps) => {
  const showAction = !!onAction && !!actionLabel

  return (
    <div className="flex flex-col items-center rounded-xl border border-dashed border-primary-subtle px-5 py-6 text-center">
      <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-xl bg-[#8B5CF6]/15">
        {icon}
      </div>
      <p className="text-[14px] font-semibold text-neutral">{title}</p>
      <p className="mt-1 text-[13px] text-neutral-faded">{description}</p>
      {showAction && (
        <Button
          onClick={onAction}
          className="mt-4 flex w-full items-center justify-center gap-2 rounded-xl border border-primary-subtle py-2.5 text-[14px] font-semibold text-neutral data-active:opacity-70"
        >
          <Plus size={16} />
          {actionLabel}
        </Button>
      )}
    </div>
  )
}

export default AssociationEmptyState